export * as share from './modules/share.js';
export * as modal from './modules/modal.js';
export * as agencyFinder from './modules/agency-finder.js';
export * as instagramA11y from './modules/instagram-a11y.js';
export const blocks = {}; // this is necessary for webpack's export modules - see webpack.config.js
